import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import Translator from "@/utils/common/Translator.ts";
import DateFieldUtils from "@/utils/common/DateFieldUtils.ts";
import NumberUtils from "@/utils/common/NumberUtils.ts";
import {ColDef, ValueFormatterFunc, ValueFormatterParams} from "ag-grid-community";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";

export default class AGGridFormatterBasedColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.valueFormatter = this.valueFormatter();
    return colDef;
  }

  private valueFormatter(): ValueFormatterFunc {
    let metaData = this.column.metaData!;
    let fieldType = metaData.fieldType;
    switch (fieldType) {
      case FieldType.Boolean:
        return (params: ValueFormatterParams): string => params.value ? Translator.translateId('yes') : Translator.translateId('no');
      case FieldType.Date:
        return (params: ValueFormatterParams): string => DateFieldUtils.dateToString(params.value);
      case FieldType.DateAndTime:
        return (params: ValueFormatterParams): string => DateFieldUtils.dateAndTimeToString(params.value);
      case FieldType.Decimal:
      case FieldType.Integer:
      case FieldType.Long:
        let specs = AGGridColumn.getFieldSpecs(metaData, this.entityType);
        return (params: ValueFormatterParams): string => {
          if (!params.value)
            return '';
          let mValue = params.value as number;
          if (specs && (specs.format || specs.decimalPlaces))
            return NumberUtils.formatByPattern(specs, mValue);
          else
            return NumberUtils.stripTrailingZeros(mValue);
        }
      case FieldType.Time:
        return (params: ValueFormatterParams): string => DateFieldUtils.timeToString(params.value, true);
      default:
        return (params: ValueFormatterParams): string => params.value;
    }
  }
}
